import Alpine from 'alpinejs';
import { postReview, REVIEW_SUBMIT_ERROR } from './review-helpers.js';

Alpine.store('otaReview', {
    listingId: null,
    firstName: '',
    lastName: '',
    email: '',
    stayMonth: '',
    stayYear: '',
    rating: 0,
    reviewText: '',
    loading: false,
    error: '',
    success: false,

    init(config = {}) {
        this.listingId = Number(config.listingId) || null;
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.stayMonth = '';
        this.stayYear = '';
        this.rating = 0;
        this.reviewText = '';
        this.loading = false;
        this.error = '';
        this.success = false;
    },

    get canSubmit() {
        return (
            this.firstName.trim() &&
            this.lastName.trim() &&
            this.email.trim() &&
            this.stayMonth &&
            this.stayYear &&
            this.rating > 0 &&
            this.reviewText.trim() &&
            !this.loading
        );
    },

    setRating(value) {
        this.rating = value;
        this.error = '';
    },

    resetForm() {
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.stayMonth = '';
        this.stayYear = '';
        this.rating = 0;
        this.reviewText = '';
        this.loading = false;
        this.error = '';
    },

    scrollToTop() {
        Alpine.nextTick(() => {
            window.requestAnimationFrame(() => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        });
    },

    async submit(formElement = null) {
        if (!this.firstName.trim() || !this.lastName.trim()) {
            this.error = 'Please enter your first and last name.';
            return;
        }

        if (!this.email.trim()) {
            this.error = 'Please enter a valid email address.';
            return;
        }

        if (!this.stayMonth) {
            this.error = 'Please select the month of your stay.';
            return;
        }

        if (!this.stayYear) {
            this.error = 'Please select the year of your stay.';
            return;
        }

        if (this.rating === 0) {
            this.error = 'Please select a rating.';
            return;
        }

        if (!this.reviewText.trim()) {
            this.error = 'Please write a review.';
            return;
        }

        if (!this.listingId) {
            this.error = 'Listing not found.';
            return;
        }

        this.loading = true;
        this.error = '';

        try {
            const data = await postReview(
                '/actions/avari/review/ota-submit',
                {
                    listingId: this.listingId,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    email: this.email,
                    stayMonth: this.stayMonth,
                    stayYear: this.stayYear,
                    rating: this.rating,
                    reviewText: this.reviewText
                },
                formElement
            );

            if (data.success) {
                this.success = true;
                this.resetForm();
                this.scrollToTop();
                return;
            }

            this.error = data.error || REVIEW_SUBMIT_ERROR;
        } catch {
            this.error = REVIEW_SUBMIT_ERROR;
        } finally {
            this.loading = false;
        }
    }
});
